export default "__VITE_ASSET__B0ab2NSZ__"